export const CLEAR_OBSERVATIONS = "CLEAR_OBSERVATIONS";
export const SET_OBSERVATION_PRODUCT = "SET_OBSERVATION_PRODUCT";